import { render, staticRenderFns } from "./document-information.vue?vue&type=template&id=6a438ec8&scoped=true&"
import script from "./document-information.vue?vue&type=script&lang=js&"
export * from "./document-information.vue?vue&type=script&lang=js&"
import style0 from "./document-information.vue?vue&type=style&index=0&id=6a438ec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a438ec8",
  null
  
)

component.options.__file = "document-information.vue"
export default component.exports